/**
 *	HISTORICAL TIMELINE
 **/
// Remove classes on any elements NOT already within the viewport
(function () {
	document.querySelectorAll("body[data-animate-historical-timeline] .historical-timeline .event").forEach(function (el) {
		// Completely outside the viewport
        if (!isElementInViewport(el)) {
            el.classList.remove("slide");
		}
	});
})();
// Add classes when any part within viewport
var slideHistoricalTimelineEvents = function () {
	document.querySelectorAll("body[data-animate-historical-timeline] .historical-timeline .event").forEach(function (el) {
		if (isElementInViewport(el)) {
			el.classList.add("slide");
		}
	});
}
window.addEventListener("scroll", slideHistoricalTimelineEvents);